import { replaceInChain } from "@insite/client-framework/HandlerCreator";
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    GetUnfilteredProducts,
    HandleSortOrderDefault,
    ParseQueryParameter,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { XProductFilters } from "@plumberssupply/XDL/types";
import qs from "qs";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        ...props.apiParameter,
        ...(props.parameter.additionalProps ?? {}),
        expand: (props.apiParameter.expand || []).concat("properties"),
    };

    // To show all products in Sub Categories
    const includeProductsInSubCategories = props.parameter?.["includeProductsInSubCategories"];
    // TOR-611: To get all attributes from Sub Categories
    const restrictAttributesToCategory = props.parameter?.["restrictAttributesToCategory"];

    if (props.apiParameter.categoryId) {
        props.apiParameter = {
            ...props.apiParameter,
            includeProductsInSubCategories,
            restrictAttributesToCategory,
        };
    }
};

/** We should remove includeProductsInSubCategories from ApiParameter because this option need CategoryId
 * and GetUnfilteredProducts remove CategoryId from ApiParameter
 */

export const XngGetUnfilteredProducts: any = (props: any) => {
    if (!props.result.productFilters.pageCategoryId) {
        const apiParameter = { ...props.apiParameter };
        if (props.apiParameter.includeProductsInSubCategories) {
            delete apiParameter.includeProductsInSubCategories;
        }
        if (props.apiParameter.restrictAttributesToCategory) {
            delete apiParameter.restrictAttributesToCategory;
        }
        props.apiParameter = {
            ...apiParameter,
        };
    }
};

export const XngParseQueryParameter: typeof ParseQueryParameter = props => {
    if (getCurrentPage(props.getState()).type === "RecentlyPurchasedPage") {
        props.result.productFilters.previouslyPurchasedProducts = true;
    }

    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substring(1) : queryString);
    const { categories } = parsedQuery;
    if (categories) {
        (props.result.productFilters as XProductFilters).categories =
            categories && typeof categories === "string" ? categories.split(",") : undefined;
    }
};

// XNG-Change: set most popular the defauld sort for PLP and best match the default for SRP
export const PlzHandleSortOrderDefault: any = (props: any) => {
    if (!props.apiParameter.sort) {
        props.apiParameter.sort = props.parameter.isSearch ? "1" : "20";
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainAfter(chain, ParseQueryParameter, XngParseQueryParameter);
addToChainBefore(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
replaceInChain(chain, HandleSortOrderDefault, PlzHandleSortOrderDefault);
